export const Allicon = ({ color = "white" }) => {
  return (
    <svg
      width="14"
      height="12"
      viewBox="0 0 14 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.08341 6C1.44175 6 0.916748 5.475 0.916748 4.83333V1.91667C0.916748 1.275 1.44175 0.75 2.08341 0.75H6.75008C7.39175 0.75 7.91675 1.275 7.91675 1.91667V4.83333C7.91675 5.475 7.39175 6 6.75008 6H5.58341V7.75L3.83341 6H2.08341ZM12.5834 9.5C13.2251 9.5 13.7501 8.975 13.7501 8.33333V5.41667C13.7501 4.775 13.2251 4.25 12.5834 4.25H9.08341V4.83333C9.08341 6.11667 8.03341 7.16667 6.75008 7.16667V8.33333C6.75008 8.975 7.27508 9.5 7.91675 9.5H9.08341V11.25L10.8334 9.5H12.5834Z"
        fill={color}
      />
    </svg>
  );
};
